import { ArticleCard } from '@xing-com/crate-career-hub-article-card';
import { Head } from '@xing-com/crate-career-hub-common';
import { HeaderNavigation } from '@xing-com/crate-career-hub-header-navigation';
import { LoggedOutFooter } from '@xing-com/crate-career-hub-logged-out-footer';
import { GridItem } from '@xing-com/grid';
import { Section, Container } from '@xing-com/layout-primitives';

import { ArticleBlockWrapper } from './article-block-wrapper';
import { SubtopicPagesData } from './cards-data';
import { TOPIC_DATA_SEO } from './constants';
import { Styled } from './subtopic-page.styles';

export type SubtopicPageEntryType = {
  topicKey: string;
};

export const SubtopicPage: React.FC<SubtopicPageEntryType> = ({ topicKey }) => {
  const {
    title: seoTitle,
    description: seoDescription,
    navigationTitle,
    pageTitle: title,
    trackingKey,
  } = TOPIC_DATA_SEO[topicKey] || {};

  const articles = SubtopicPagesData.get(topicKey)?.articles;
  const trackingSuffix = `?sc_o=career_hub_application_article_click&sc_o_PropActionOrigin=career_hub_application_${trackingKey}`;

  return (
    <Section noBlockPadding>
      <Head
        titleTranslationKey={seoTitle}
        descriptionTranslationKey={seoDescription}
      />
      <Container>
        <HeaderNavigation title={navigationTitle} />
        <Styled.Hero size="small">{title}</Styled.Hero>
      </Container>
      <ArticleBlockWrapper>
        {articles?.map((article) =>
          article ? (
            <GridItem key={article.title} spanMedium={6} spanLarge={4}>
              <ArticleCard
                {...{
                  pageTitle: article?.pageTitle,
                  description: article?.description,
                  imageSrc: article?.imageSrc ?? '',
                  title: article?.title,
                  url: `${article?.url + trackingSuffix}`,
                  profileImage: article?.profileImage ?? '',
                }}
              />
            </GridItem>
          ) : null
        )}
      </ArticleBlockWrapper>
      <LoggedOutFooter topicKey={trackingKey} />
    </Section>
  );
};
